import React from "react";

import {
  CheckForm,
  Flex,
  Grid,
  Group,
  Input,
  Section,
} from "@samskip/frontend-components";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { getErrorMessage } from "@assets/utilities/translateUtilities";

import { CalculatePriceTranslation, InputConstraint } from "../../constants";
import { CalculatorForm } from "../../formValues";

interface GoodsCharacteristicsSectionProps {
  errors: FieldErrors<CalculatorForm>;
  isCalculating: boolean;
  register: UseFormRegister<CalculatorForm>;
}

const GoodsCharacteristicsSection = ({
  errors,
  isCalculating,
  register,
}: GoodsCharacteristicsSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section title={t(CalculatePriceTranslation.DETAILS)}>
      <Grid mdCol={4}>
        <Input
          disabled={isCalculating}
          errorMessage={getErrorMessage("Weight", errors, {
            n: InputConstraint.MIN_INPUT_WEIGHT,
            maxVal: InputConstraint.MAX_INPUT_WEIGHT,
          })}
          fullWidth
          hasError={errors["Weight"] != null}
          id="weight"
          infoMessage={t(CalculatePriceTranslation.WEIGHT_TOOLTIP)}
          label={t(CalculatePriceTranslation.WEIGHT) + " (KG)"}
          placeholder={t(CalculatePriceTranslation.PLACEHOLDER_GROSS_WEIGHT)}
          required
          step="1"
          type="number"
          {...register("Weight")}
        />
        <Input
          disabled={isCalculating}
          errorMessage={getErrorMessage("Volume", errors, {
            n: InputConstraint.MIN_INPUT_VOLUME,
            maxVal: InputConstraint.MAX_INPUT_VOLUME,
          })}
          fullWidth
          hasError={errors["Volume"] != null}
          id="volume"
          infoMessage={t(CalculatePriceTranslation.VOLUME_TOOLTIP)}
          label={t(CalculatePriceTranslation.VOLUME) + " (M3)"}
          placeholder={t(CalculatePriceTranslation.PLACEHOLDER_VOLUME)}
          required
          step="0.001"
          type="number"
          {...register("Volume")}
        />
      </Grid>

      <Group title={t(CalculatePriceTranslation.SPECIAL_HANDLING)}>
        <Flex alignItems="start" gap="large">
          <CheckForm
            disabled={isCalculating}
            id="is-dangerous"
            label={t(CalculatePriceTranslation.HAZARDOUS)}
            type="checkbox"
            {...register("IsDangerous")}
          />
          <CheckForm
            disabled={isCalculating}
            id="is-fragile"
            label={t(CalculatePriceTranslation.FRAGILE)}
            type="checkbox"
            {...register("IsFragile")}
          />
          <CheckForm
            disabled={isCalculating}
            id="is-temperature"
            label={t(CalculatePriceTranslation.TEMPERATURE)}
            type="checkbox"
            {...register("IsTemperatureControlled")}
          />
        </Flex>
      </Group>
    </Section>
  );
};

export default GoodsCharacteristicsSection;
